import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import LoginComponent from '../components/login/login.jsx';
import {openHomeModal} from "../redux/actions/modelsActive";
import {loginRequest, getTeacherInfoRequest,qrCodePollingRequest} from "../service/user";
import PubSub from "pubsub-js";
import {API_URL, APP_KEY} from "../util/constants";

var pollTimer = null;

class LoginContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'clickTab',
            'showToast',
            'onRef',
            'sendMsg',
            'onErrorMsg',
            'phoneNumberChange',
            'codeChange',
            'loginByPwd',
            'loginByRecord',
            'clear',
            'qrCodePolling',
            'startPoll',
            'refreshQRCode'
        ]);
        this.state = {
            option: {},
            num: 9,
            tab: 1,
            phoneNumberValue: '',
            codeValue: '',
            recordList: [],
            dianzanList: [],
            showLoading:true,
            QRCodeContent:'',
            QRStatus:true
        }

        PubSub.unsubscribe('loginOut');
        PubSub.subscribe('loginOut', (event, data) => {
            console.log('接收退出登录')
            console.log(localStorage.getItem('userLoginList'))
            var list = [];
            if (localStorage.getItem('userLoginList')) {
                list = JSON.parse(localStorage.getItem('userLoginList'));
                this.setState({
                    recordList: list
                })
                localStorage.setItem('userLoginList', JSON.stringify(list));
            }

            //扫码相关
            if(this.state.tab===1){
                clearInterval(pollTimer);
                this.startPoll();
            }

        });
    }


    timeNow(){
        var nowDate = new Date();
        var year = nowDate.getFullYear();
        var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
            .getDate();

        var d = new Date();
        var hour= d.getHours()< 10 ? "0" +d.getHours():d.getHours();//得到小时数
        var minute= d.getMinutes()< 10 ? "0" +d.getMinutes():d.getMinutes();//得到分钟数
        var second= d.getSeconds()< 10 ? "0" +d.getSeconds():d.getSeconds();//得到秒数

        var dateStr = year  + ''+ month  + '' + day  + ''+ hour + '' + minute + '' + second;

        // console.log('year=='+year)
        // console.log('month=='+month)
        // console.log('day=='+day)
        // console.log('hour=='+hour)
        // console.log('minute=='+minute)
        // console.log('second=='+second)
        // console.log('dateStr=='+dateStr)


        return dateStr;
    }


    componentDidMount() {

        //2022050715

        this.startPoll();


        if (sessionStorage.getItem('teacherphone')) {
            this.props.openHomeModal();
        }
        var list = [];
        if (localStorage.getItem('userLoginList')) {
            list = JSON.parse(localStorage.getItem('userLoginList'));
            this.setState({
                recordList: list
            })

            localStorage.setItem('userLoginList', JSON.stringify(list));
        }

        setTimeout(() => {
            this.setState({
                showLoading: false,
            });
        }, 2000);

    }

    startPoll(){
        var str = 'appkey:xixin:loginbyqrcode:';
        var strTimeAndNumber = this.timeNow() + Math.floor(Math.random() * 999999);
        var QRCodeContent = str + strTimeAndNumber;
        var str_erweima = strTimeAndNumber;
        console.log('str_erweima=='+str_erweima)

        console.log('QRCodeContent=='+QRCodeContent)


        var abc = str_erweima.substring(0,14);
        console.log('time=='+abc);

        this.setState({
            QRCodeContent:QRCodeContent,
            QRStatus:true
        })

        var that = this;
        var n=0;
         pollTimer = setInterval(function () {
            n=n+1
            //that.qrCodePolling(n,str_erweima);
            console.log('轮询次数=='+n)
            qrCodePollingRequest(str_erweima, (data) => {
                console.log(data)
                if (data.ret == '1') {
                    var teacher_phone = data.data.teacherphone;
                    console.log(data.data);
                    console.log(teacher_phone);

                    var temData = data.data;
                    for (var key in temData) {
                        var item = temData[key]
                        try {
                            sessionStorage.setItem(key, item)
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    var list = [];//历史登录列表
                    if (localStorage.getItem('userLoginList')) {
                        list = JSON.parse(localStorage.getItem('userLoginList'));
                    }
                    if(!that.contains(list,teacher_phone)){
                        list.push({
                            'phone': teacher_phone,
                            'name': temData.name,
                            'teacherimg': temData.teacherimg
                        })
                        localStorage.setItem('userLoginList', JSON.stringify(list));
                    }
                    that.props.openHomeModal();


                    clearInterval(pollTimer)
                } else {

                }
            });


            if(n==6){
                console.log('轮询结束')
                clearInterval(pollTimer)

                // var str = 'appkey:xixin:loginbyqrcode:';
                // var strTimeAndNumber = this.timeNow() + Math.floor(Math.random() * 999999);
                // var QRCodeContent = str + strTimeAndNumber;
                // var str_erweima = strTimeAndNumber;
                that.setState({
                    QRStatus:false
                })

                //that.startPoll();

            }
        },5000)
    }

    refreshQRCode(){
        this.setState({
            QRStatus:true
        })
        this.startPoll();
    }


    qrCodePolling(n,str_erweima){
        console.log('轮询次数=='+n)
        qrCodePollingRequest(str_erweima, (data) => {
            console.log(data)
            if (data.ret == '1') {

            } else {

            }
        });
    }


    clear(){
        localStorage.clear();
        this.setState({
            recordList: []
        })
    }

    clickTab(tab) {
        this.setState({
            tab: tab
        })

        if(tab===2){
            //add
            clearInterval(pollTimer)
        }else if(tab===1){
            //add
            clearInterval(pollTimer)
            this.startPoll();
        }
    }

    showToast(msg, duration) {
        duration = isNaN(duration) ? 3000 : duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText = "min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function () {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function () {
                document.body.removeChild(m)
            }, d * 1000);
        }, duration);
    }

    sendMsg(e) {

        if (this.state.phoneNumberValue === '') {
            this.setState({
                errMsg: "请输入手机号"
            });
            this.showToast("请输入手机号", 2000);
            return;
        }

        if (!this.isPhoneNumber(this.state.phoneNumberValue)) {
            this.setState({
                errMsg: "手机号码格式不正确"
            });
            this.showToast("手机号码格式不正确", 2000);
            return;
        }

        if (this.isPhoneNumber(this.state.phoneNumberValue)) {
            sessionStorage.setItem('phone_zhuce', this.state.phoneNumberValue)
            this.child.start();
        }
    }


    onRef(ref) {
        this.child = ref;

    }

    onErrorMsg(msg) {
        this.showToast(msg, 2000);
    }

    //判断是否为手机号的正则表达式
    isPhoneNumber(phones) {
        var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(phones)) {
            this.setState({
                errMsg: '手机号格式不正确'
            });
            return false;
        } else {
            this.setState({
                errMsg: ''
            });
            return true;
        }
    }

    phoneNumberChange(phone) {
        this.setState({
            phoneNumberValue: phone.replace(/\s/g, '')
        });
    }

    codeChange(code) {
        this.setState({
            codeValue: code.replace(/\s/g, '')
        });
    }

    contains(arr, val) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].phone === val) {
                return true;
            }
        }
        return false;
    }

    loginByPwd() {

        // this.props.openHomeModal();
        //
        // return;

        // this.props.openHomeModal();
        if (this.state.phoneNumberValue === '') {
            this.setState({
                errMsg: "请输入手机号"
            });
            this.showToast("请输入手机号", 2000);
            return;
        }

        if (!this.isPhoneNumber(this.state.phoneNumberValue)) {
            this.setState({
                errMsg: "手机号码格式不正确"
            });
            this.showToast("手机号码格式不正确", 2000);
            return;
        }
        if (this.state.codeValue === '') {
            this.setState({
                errMsg: "请输入验证码"
            });
            this.showToast("请输入验证码", 2000);
            return;
        }

        loginRequest(this.state.phoneNumberValue, this.state.codeValue, (data) => {
            console.log(data)
            if (data.ret == '1') {

                getTeacherInfoRequest(this.state.phoneNumberValue, (data) => {
                    console.log(data)
                    if (data.ret == '1') {

                        var temData = data.data;
                        for (var key in temData) {
                            var item = temData[key]
                            try {
                                sessionStorage.setItem(key, item)
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        var list = [];//历史登录列表

                        if (localStorage.getItem('userLoginList')) {
                            list = JSON.parse(localStorage.getItem('userLoginList'));
                        }

                        console.log(this.contains(list,this.state.phoneNumberValue))

                        if(!this.contains(list,this.state.phoneNumberValue)){
                            list.push({
                                'phone': this.state.phoneNumberValue,
                                'name': temData.name,
                                'teacherimg': temData.teacherimg
                            })
                            localStorage.setItem('userLoginList', JSON.stringify(list));
                        }

                        this.props.openHomeModal();

                        //add
                        clearInterval(pollTimer)
                    } else {
                        this.showToast(data.msg, 2000);
                    }
                });
                //this.props.openHomeModal();
            } else {
                this.showToast(data.msg, 2000);
            }
        });
    }

    loginByRecord(phone) {
        getTeacherInfoRequest(phone, (data) => {
            console.log(data)
            if (data.ret == '1') {

                var temData = data.data;
                for (var key in temData) {
                    var item = temData[key]
                    try {
                        sessionStorage.setItem(key, item)
                    } catch (e) {
                        console.error(e)
                    }
                }
                // var list = [];//历史登录列表
                //
                // if (localStorage.getItem('userLoginList')) {
                //     list = JSON.parse(localStorage.getItem('userLoginList'));
                // }
                //
                // list.push({
                //     'phone': this.state.phoneNumberValue,
                //     'name': temData.name,
                //     'teacherimg': temData.teacherimg
                // })
                // localStorage.setItem('userLoginList', JSON.stringify(list));
                this.props.openHomeModal();

                //add
                clearInterval(pollTimer)
            } else {
                this.showToast(data.msg, 2000);
            }
        });
    }

    render() {

        return (
            <LoginComponent
                recordList={this.state.recordList}
                tab={this.state.tab}
                clickTab={this.clickTab}
                onRef={this.onRef}
                sendMsg={this.sendMsg}
                onErrorMsg={this.onErrorMsg}
                phoneNumberChange={this.phoneNumberChange}
                phoneNumberValue={this.state.phoneNumberValue}
                codeChange={this.codeChange}
                codeValue={this.state.codeValue}
                loginByPwd={this.loginByPwd}
                loginByRecord={this.loginByRecord}
                clear={this.clear}
                showLoading={this.state.showLoading}
                QRCodeContent={this.state.QRCodeContent}
                QRStatus={this.state.QRStatus}
                refreshQRCode={this.refreshQRCode}
            />
        )
    }


}

LoginContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        openHomeModal: () => dispatch(openHomeModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginContainer);
